import { useEffect, useState } from 'react';

/** Een waarde die pas meebeweegt als de gebruiker even stopt met typen. */
export function useDebounced<T>(value: T, delayMs = 300): T {
    const [settled, setSettled] = useState(value);

    useEffect(() => {
        const timer = setTimeout(() => setSettled(value), delayMs);

        return () => clearTimeout(timer);
    }, [value, delayMs]);

    return settled;
}
